import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class PortfolioType extends ModelBase {
    static typeName = "PortfolioType";

    public portfolioTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public portfolioTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.portfolioTypeName) {
            return "New portfolio type";
        } else {
            return this.portfolioTypeName;
        }
    }
}